import { useState, useContext, useRef } from 'react';

import { useQuery } from '@tanstack/react-query';

import authAxios from '../../components/authAxios';
import {UserContext} from "../../App"

import { TextField, Autocomplete } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import {Button as MUIButton} from "@mui/material";

import { Modal, Upload, Button, message } from 'antd';

import { UploadOutlined } from '@ant-design/icons';

import NumberFormat from "react-number-format";

import './Loans.css'

const LoanSecurity = ({ addSecurity, isModalOpen, setIsModalOpen, loanSecurities, setLoanDocs }) => {
    const { pageSize } = useContext(UserContext);
    const { maxFileSizeMB } = useContext(UserContext);
    
    const validDataRef = useRef(false);

    const [securityType, setSecurityType] = useState();
    const [documentType, setDocumentType] = useState();
    const [amount, setAmount] = useState();
    const [memo, setMemo] = useState();
    const [amountError, setAmountError]=useState(false)


    const beforeUpload = (file) => {
        const isTooLarge = file.size / 1024 / 1024 > maxFileSizeMB;
        if (isTooLarge) {
            message.error(`File too large. Maximum size is ${maxFileSizeMB}MB.`);
            return Upload.LIST_IGNORE; // prevents adding to UI list
        }
        return false; // continue with manual upload handling
        };
    

    const handleFileUpload = (info, doc_type) => {
        console.log("UPLOAD INFO", info)    
        console.log("DOCUMENT TYPE", doc_type)
        const fileList = info.fileList.map(f => {
            return {
            uid: f.uid,
            name: f.name,
            file: f.originFileObj || f,
            document_type: doc_type,
            // document_number: document_number || '',
            // issue_date: issue_date || null,
            // expiry_date: expiry_date || null,
            };
        });

        console.log("FILE LIST SECURITIES", fileList)

        setLoanDocs(fileList);

        // if (type === 'PROFILE_PHOTO') {
        //     console.log("FILE LIST PHOTOS", fileList)
        //     setPhoto(fileList[0]); // only one photo
        // } else {
        //     setContactDocs(fileList);
        // }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const { data: securityTypes } = useQuery({
        queryKey: ['securityTypes'],
        queryFn: async () => {
          const response = await authAxios.get(`/loans/security-types?page_size=${pageSize}`);
          return response.data.results;
        },
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        validDataRef.current=true  
        
        // const expenseAmount = cashFlowCategory.category === "EXPENSE" ? amount : 0
        // const incomeAmount = cashFlowCategory.category === "INCOME" ? amount : 0

        const newSecurity = {
            id: securityType.id,
            security_type:securityType.id,
            name:securityType.name,
            category:securityType.category_name,
            value:amount,
            memo:memo
            // frequency:frequency,
            // expenseAmount:expenseAmount, // Used for table display
            // incomeAmount:incomeAmount, // Used for table display
        };

        addSecurity(newSecurity);
        setIsModalOpen(false);
    };

    return (
        <>
        <div className="product-details-container application-guarantor-container">
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>#</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Value</th>
                        <th></th>
                    </tr>
                </thead>
                {loanSecurities && loanSecurities.map((security, index) => (
                    <tbody key={index}>
                        <tr>
                            <td>{security.id}</td>
                            <td>{security.name}</td>
                            <td>{security.category}</td>
                            <td>{Number(security.value).toLocaleString()}</td>
                            <td>
                                <IconButton 
                                    size="small">
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>
        </div>

        <div className="AddRow">
            <MUIButton
                id="AddRowButton"
                onClick={() => {
                    setIsModalOpen(true)}
                }
                variant="outlined" 
                size="small"
                startIcon={<AddCircleOutlineIcon />}
            >
                Security
            </MUIButton>
        </div>
        {isModalOpen && 
            <Modal className="dashboard-modal" title="Add Loan Security" visible={isModalOpen} open={isModalOpen} onOk={handleSubmit} onCancel={handleCancel}>
                <div className="dashboard-form">
                    <form onSubmit={handleSubmit}>
                        <Autocomplete
                            onChange={(event, newValue) => {
                                setSecurityType(newValue);
                                console.log("SELECTED SECURITY TYPE", newValue)
                                if (newValue.category==="VEHICLE"){
                                    setDocumentType("LOGBOOK");
                                }
                                if (newValue.category==="PROPERTY"){
                                    setDocumentType("TITLE_DEED");
                                }
                            }}
                            options={securityTypes}
                            getOptionLabel={(option) => option? option.name: ""}
                            renderInput={(params) => 
                                <TextField 
                                    className='custom-input'
                                    label="Type" 
                                    {...params} 
                                />
                            }
                        />
                        <TextField className="custom-input"
                            value={securityType?securityType.category_name:""}
                            label="Category"
                            variant="outlined" 
                            fullWidth
                            disabled
                        /> 

                        <NumberFormat 
                            onChange={(e) => {
                                const amt = parseFloat(e.target.value.replace(/,/g, ''))
                                if (amt>0){
                                    setAmountError(false)
                                    setAmount(amt)
                                }
                                else{
                                    setAmountError(true)
                                }
                            }} 
                            className="custom-input"
                            fullWidth
                            label="Value" 
                            variant="outlined" 
                            customInput={TextField}
                            thousandSeparator={true} 
                            required
                        />

                        <TextField className="custom-input"
                            // value={securityType?securityType.category_name:""}
                            onChange={(e) => setMemo(e.target.value)}
                            label="Additional Information"
                            variant="outlined" 
                            fullWidth
                            multiline
                            rows={3}
                            // disabled
                        /> 

                        <Upload
                            name="file"
                            beforeUpload={beforeUpload}
                            onChange={(info) => handleFileUpload(info, documentType)}
                            maxCount={1}
                        >
                            <Button
                                style={{ marginTop: '1.5rem' }}
                                icon={<UploadOutlined />}
                            >
                                Click to Upload
                            </Button>
                        </Upload>

                    </form>
                </div>
            </Modal>
        }
        </>

    );
};

export default LoanSecurity;
